import { render, staticRenderFns } from "./Kits.vue?vue&type=template&id=538b2444&scoped=true"
import script from "./Kits.vue?vue&type=script&lang=js"
export * from "./Kits.vue?vue&type=script&lang=js"
import style0 from "./Kits.vue?vue&type=style&index=0&id=538b2444&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538b2444",
  null
  
)

export default component.exports